import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { IconMinus, IconPlus } from "icons";

import Text from "./Text";

import styles from "./Counter.module.scss";

function Counter({
  ariaLabelIncrement,
  ariaLabelDecrement,
  count,
  onDecrement,
  onIncrement,
  max,
  size,
  greaterThan,
}) {
  const fontSize = size === "sm" ? "sm" : "md";

  return (
    <div className={classnames(styles.button__container, styles[size])}>
      <button
        aria-label={ariaLabelDecrement || "Decrement"}
        type="button"
        className={classnames(styles.button)}
        onClick={onDecrement}
      >
        <IconMinus size="sm" color="deep-green" />
      </button>
      <Text types={[fontSize, "inline"]}>
        {count.toString()}
        {greaterThan && <span> +</span>}
        {!greaterThan && count === max ? "+" : ""}
      </Text>
      <button
        aria-label={ariaLabelIncrement || "Increment"}
        type="button"
        className={classnames(styles.button)}
        onClick={onIncrement}
      >
        <IconPlus size="sm" color="deep-green" />
      </button>
    </div>
  );
}

Counter.propTypes = {
  ariaLabelIncrement: PropTypes.string,
  ariaLabelDecrement: PropTypes.string,
  count: PropTypes.number.isRequired,
  onDecrement: PropTypes.func.isRequired,
  onIncrement: PropTypes.func.isRequired,
  max: PropTypes.number,
  size: PropTypes.oneOf(["sm", "md", ""]),
  greaterThan: PropTypes.bool,
};

Counter.defaultProps = {
  max: Number.MAX_SAFE_INTEGER,
  size: "",
  greaterThan: false,
};

export default Counter;
